import React from 'react';
import { reduxForm, formValueSelector, change } from 'redux-form/immutable';
import { Alert, Col, Button, Card, message } from 'antd'
import { connect } from "react-redux";
import { fromJS } from 'immutable'
import Guardian1 from "./TransferStudentForm/Guardian1";
import Guardian2 from "./TransferStudentForm/Guardian2";
import { updateParentPassImg } from "../../actions";

const formFieldsetStyle = {
    border: 0,
    margin: 0,
    padding: 0,
    minWidth: 0,
};

class ParentPassForm extends React.Component {
    componentDidMount() {
        console.log('ParentPassForm 掛載 - guardian1_img:', this.props.guardian1ImgValue);
        console.log('ParentPassForm 掛載 - guardian2_img:', this.props.guardian2ImgValue);
        console.log('API_SERVER:', API_SERVER);
    }
    
    componentDidUpdate(prevProps) {
        if (prevProps.guardian1ImgValue !== this.props.guardian1ImgValue) {
            console.log('ParentPassForm 更新 - 新guardian1_img:', this.props.guardian1ImgValue);
        }
        if (prevProps.guardian2ImgValue !== this.props.guardian2ImgValue) {
            console.log('ParentPassForm 更新 - 新guardian2_img:', this.props.guardian2ImgValue);
        }
    }
    
    render() {
        const { isLocked, handleSubmit } = this.props;

        return (
            <div>
                {isLocked && (
                    <Alert
                        type="warning"
                        showIcon
                        style={{ marginBottom: '16px' }}
                        message="此表單已由註冊組鎖定，請聯繫註冊組開啟後再修改。"
                    />
                )}

                <Card title="家長接送證製作須知  (搭校車者也需要製作此證)">
                    <Col span={18}>
                        親愛的家長，為了讓上學、放學接送小朋友更快速、安全，請務必配合下列事項：<br />
                    1、	為了您行車安全及避免塞車，請依照右圖中指示接送小朋友，請勿插隊，更請勿在河北路上直接迴車。<br />
                    2、	放學時間請到校接送的家長於門口等候，開車接送的家長請於車上等候，告知導護老師廣播，由老師接給家長。<br />
                    3、學生放學時間為4：50以及5：40，請家長能在5:00及5:50到校，避開放學尖峰時段，減少您等候的時間。<br />
                    4、學校會製作【家長接送證】，接送小朋友時，請務必出示【家長接送證】，以利辨別。（幸福第一天活動時發下）<br />
                    5、若家長委託他人至學校接送學生，請事先以電話聯繫，告知導師來接者之姓名與學生關係，或將【家長接送證】交付來接者。<br/>
                    經導護老師查證或檢視【家長接送證】，確認無誤才讓學生離開校園。<br />
                    6、開車家長：請將【家長接送證】置於轎車右前方擋風玻璃處，【家長接送證】請妥善保存，如有遺失請向學務處申請補發。<br />
                    7、如未出示【家長接送證】，學校將聯絡家長，確認後方可放行，感謝您的配合!<br />
                    </Col>
                    <Col span={6}>
                        <img alt="school_map" src="/images/school_map.png" style={{ width: '100%', height: '100%' }} />
                    </Col>
                </Card>
                <br />
                <Card>
                    親愛的家長：<br />
                    學校將製作「家長接送證」，為了學生安全以及能讓所有老師易於辨認，請上傳平常會來接學生的2位親人之證件照。<br />
                    <form onSubmit={isLocked ? undefined : handleSubmit} noValidate>
                        <fieldset disabled={isLocked} style={formFieldsetStyle}>
                            <Col span={12}>
                                <Guardian1 {...this.props} changGuardian1Img={this.changGuardian1Img} />
                            </Col>
                            <Col span={12}>
                                <Guardian2 {...this.props} changGuardian2Img={this.changGuardian2Img} />
                            </Col>
                        </fieldset>
                        <Button
                            htmlType="submit"
                            type={'primary'}
                            size={'large'}
                            disabled={isLocked}
                            style={{ width: '100%', marginTop: '10px' }}
                        >
                            {isLocked ? '已鎖定' : '送出'}
                        </Button>
                    </form>
                </Card>
                <br />
                <Card title="照片上傳說明">
                    <img alt="example" src="/images/ID-images.jpg" style={{ width: '100%', height: '100%' }} />

                </Card>
                <br />
            </div>
        )
    }

    changGuardian1Img = (file) => {
        if (this.props.isLocked) {
            message.warning('此表單已鎖定，無法上傳照片');
            return;
        }

        if (file && file.length > 0) {
            // 為檔案建立一個臨時URL
            const imageUrl = file[0].preview || URL.createObjectURL(file[0]);
            this.props.changeFieldValue('guardian1_img', imageUrl);
            this.props.updateParentPassImg('guardian1_img', file);
        }
    }
    
    changGuardian2Img = (file) => {
        if (this.props.isLocked) {
            message.warning('此表單已鎖定，無法上傳照片');
            return;
        }

        if (file && file.length > 0) {
            // 為檔案建立一個臨時URL
            const imageUrl = file[0].preview || URL.createObjectURL(file[0]);
            this.props.changeFieldValue('guardian2_img', imageUrl);
            this.props.updateParentPassImg('guardian2_img', file);
        }
    }
}

ParentPassForm = reduxForm({
    form: 'editParentPass', // a unique identifier for this form
    enableReinitialize: true,
})(ParentPassForm)
const mapDispatchToPorps = (dispatch) => ({
    changeFieldValue: function (field, value) {
        dispatch(change('editParentPass', field, value))
    },
    updateParentPassImg: (imgNmae, payload) => (
        dispatch(updateParentPassImg(dispatch, imgNmae, payload))

    )
})
const selector = formValueSelector('editParentPass')
ParentPassForm = connect(
    state => {
        const data = state.getIn(['ParentPass', 'data']);
        const safeData = data && data.toJS ? data.toJS() : (data || {});
        return {
            guardian1ImgValue: selector(state, 'guardian1_img'),
            guardian2ImgValue: selector(state, 'guardian2_img'),
            initialValues: fromJS(safeData),
            isLocked: !!safeData.ques_check,
        };
    },
    mapDispatchToPorps)(ParentPassForm)
export default ParentPassForm



// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/ParentPassContaioner/ParentPassForm.jsx